import React from 'react';
import Header from './Header';
import Slides from './Slides';
import Packs from './Packs';
import NuestroTrabajo from './NuestroTrabajo';
import Galery from './Galery';
import NextEvent from './NextEvent';

const Home = () => {
  return (
    <div
      id="page"
      className="site"
      itemScope=""
      itemType="http://schema.org/LocalBusiness"
    >
      <Header />
      <Slides />

      {/* Paquetes populares */}
      <div className="page-heading">
        <div className="container">
          <h2>Paquetes Populares</h2>
          <Packs/>
        </div>
      </div>
      {/* Paquetes populares End */}


      <NuestroTrabajo />

      {/* Galeria */}
      <Galery />
      {/* Galeria End */}

      {/* Events section Start */}
      <NextEvent />
      {/* End of Events section */}

      {/* footer */}
      <footer
        className="page-footercue"
        id='footer'
        itemProp="footer"
        itemScope=""
        itemType="http://schema.org/WPFooter"
      >
        <div className="footer-first-sectioncue">
          <div className="containercue">
            <div className="box-wrapcue" itemProp="about">
              <header>
                <h1>Acerca de Nosotros</h1>
              </header>
              <p>
              Cue Ilisound es una empresa dedicada a rentar equipos de audio e iluminación para todo tipo de eventos, desde bodas y fiestas, hasta eventos culturales, obras de teatro y danza. Contamos con un equipo conformado por ingenieros y licenciados altamente capacitados y experimentados en el manejo de equipos de audio e iluminación.<br></br> <br></br>

En Cue Ilisound nos enfocamos en ofrecer soluciones integrales para todo tipo de eventos, garantizando que cada uno de nuestros clientes reciba el mejor servicio y calidad de audio e iluminación. Trabajamos con equipos de última generación y utilizamos las mejores marcas en el mercado, lo que nos permite ofrecer un sonido e iluminación de alta calidad y que cumpla con las expectativas de nuestros clientes.<br></br> <br></br>

Además, en Cue Ilisound nos preocupamos por la seguridad y bienestar de nuestros clientes, por lo que nos aseguramos de que nuestros equipos sean instalados y operados por personal altamente capacitado y experimentado en el área de audio e iluminación. De esta forma, nuestros clientes pueden estar seguros de que sus eventos serán un éxito y que contarán con el mejor servicio y calidad en cuanto a audio e iluminación se refiere.<br></br> <br></br>

Si estás buscando una empresa confiable y profesional para rentar equipos de audio e iluminación para tus eventos, no dudes en contactar a Cue Ilisound. Estamos seguros de que podremos ofrecerte la solución que estás buscando y garantizar el éxito de tu evento.
              </p>
            </div>
            <div className="box-wrapcue">
              <h4>
                <a href="tel:4433890008">
                  <i className="fas fa-phone" /> 443 389 0008
                </a>
              </h4>
              <h4>
                <a href="mailto:cueilisound_teatro@gmail.com">
                  <i className="fas fa-envelope" /> cueilisound_teatro@gmail.com
                </a>
              </h4>
              <h4>
                <a href="">
                  <i className="fas fa-map-marker-alt" />
                  Morelia, Michoacan, Mexico
                </a>
              </h4>
            </div>
          </div>
        </div>
      </footer>
      {/* End of Others talk section */}
    </div>
  );
};

export default Home;
